import { createActions, handleActions } from 'redux-actions';

const initState = {
  queryData: {},

  fetching: false,
  error: null,
};

export const creators = createActions({
  WORKGENERATED_QUERY_REQUEST: (selectedYears) => ({ selectedYears }),
  WORKGENERATED_SUCCESS: (payload) => payload,
  WORKGENERATED_FAILURE: (payload) => payload,
});

const queryReducer = (state) => {
  return { ...state, fetching: true, error: null };
};

const successReducer = (state, { payload }) => {
  const nextState = Object.assign({}, state, payload);
  nextState.fetching = false;
  return nextState;
};

const failureReducer = (state, { payload }) => {
  return { ...state, fetching: false, error: payload };
};

export default handleActions(
  {
    WORKGENERATED_QUERY_REQUEST: queryReducer,
    WORKGENERATED_SUCCESS: successReducer,
    WORKGENERATED_FAILURE: failureReducer,
  },
  initState,
);
